import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import getInitials from 'common/getInitials';
import Text from 'components/_core/Text';

interface ClientAvatarProps {
  name: string;
}

const ClientAvatar: FC<ClientAvatarProps> = ({ name }) => (
  <Flex
    alignItems="center"
    backgroundColor="grey.200"
    borderRadius="radius-12"
    boxSize="48px"
    justifyContent="center"
    padding="space-4"
  >
    <Text fontWeight="weight-500">{getInitials(name)}</Text>
  </Flex>
);

export default ClientAvatar;
